import { useCallback } from "react";

export type Message = {
  type: string;
  payload: {
    widgetCode: string;
    height: number;
  };
};

const useEmbedded = () => {
  const isInIframe =
    typeof window.self !== "undefined" &&
    typeof window.top !== "undefined" &&
    window.self !== window.top;

  const postMessageToParent = useCallback((message: Message) => {
    if (!isInIframe) {
      return;
    }

    window.parent.postMessage(message, "*");
  }, [isInIframe]);

  return {
    postMessageToParent,
  };
};

export default useEmbedded;

